var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumerReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "119.0055 95.0398 57.041 34.5634",
    width: "57.041px",
    height: "34.5634px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1563 15.8416V8.01689H42.8896C45.0632 8.01689 46.8499 9.79319 46.8499 11.9531C46.8499 14.1135 45.0632 15.8416 42.8896 15.8416H38.1563ZM23.5698 23.3784C21.9763 24.9623 19.8027 25.9223 17.3878 25.9223C12.606 25.9223 8.69408 22.0343 8.69408 17.2818C8.69408 12.5291 12.606 8.64107 17.3878 8.64107C19.8027 8.64107 21.9763 9.60123 23.5698 11.185L29.4626 5.32873V29.2348L23.5698 23.3784ZM29.4626 34.0834H38.1563V23.3784H40.7163L46.9951 34.0834H57.041L49.41 21.7462C53.0325 19.8739 55.544 16.1297 55.544 11.7611C55.544 5.52069 50.4245 0.480168 44.1938 0.480168H29.4626V4.84856C26.2745 1.87237 22.0728 0 17.3878 0C7.82469 0 0 7.68109 0 17.2818C0 26.8825 7.82469 34.5634 17.3878 34.5634C22.0728 34.5634 26.2745 32.691 29.4626 29.7148V34.0834Z",
    fill: "#00AE3D",
    transform: "matrix(1, 0, 0, 1, 119.00553131103517, 95.03980255126955)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumerReports);
export default __webpack_public_path__ + "static/media/consumer-reports.3d168cde72f68c2b73921a0cfee133d9.svg";
export { ForwardRef as ReactComponent };